import { render, staticRenderFns } from "./OrderCotizationEdit.vue?vue&type=template&id=34f57e75&"
import script from "./OrderCotizationEdit.vue?vue&type=script&lang=js&"
export * from "./OrderCotizationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports